import * as deploy from './deploy.ts';

export { deploy };
